import React, { useState } from 'react';
import TransactionAll from '../components/Transaction/Tab/TransactionAll';
import TransactionFail from '../components/Transaction/Tab/TransactionFail';
import TransactionNeedAction from '../components/Transaction/Tab/TransactionNeedAction';
import TransactionSuccess from '../components/Transaction/Tab/TransactionSuccess';
import LayoutDashboard from '../layout/LayoutDashboard';

const Transaction = () => {
  const [showTabTransaction, setShowTabTransaction] = useState(1);
  let showTab = null;
  switch (showTabTransaction) {
    case 1:
      showTab = <TransactionAll />;
      break;
    case 2:
      showTab = <TransactionNeedAction />;
      break;
    case 3:
      showTab = <TransactionSuccess />;
      break;
    case 4:
      showTab = <TransactionFail />;
      break;

    default:
      return <div> Error</div>;
  }
  return (
    <>
      <LayoutDashboard>
        <section className="ml-4 w-full pr-4">
          <div className="md-flex">
            <div className="bg-background-white min-h-screen flex flex-col">
              <div className="flex flex-col sm:flex-row bg-white">
                <button
                  className={
                    'py-4 px-6 block focus:outline-none border-b-2 font-medium ' +
                    (showTabTransaction === 1
                      ? '  text-orange-500 border-orange-500'
                      : ' hover:text-orange-500 border-transparent')
                  }
                  onClick={() => {
                    setShowTabTransaction(1);
                  }}
                >
                  Semua
                </button>
                <button
                  className={
                    'text-gray-700 py-4 px-6 block hover:text-orange-500 border-b-2 focus:outline-none ' +
                    (showTabTransaction === 2
                      ? 'text-orange-500 border-orange-500 '
                      : ' hover:text-orange-500 border-transparent')
                  }
                  onClick={() => {
                    setShowTabTransaction(2);
                  }}
                >
                  Perlu tindakan
                </button>
                <button
                  className={
                    'text-gray-700 py-4 px-6 block hover:text-orange-500 border-b-2 focus:outline-none ' +
                    (showTabTransaction === 3
                      ? ' text-orange-500 border-orange-500 '
                      : ' hover:text-orange-500 border-transparent')
                  }
                  onClick={() => {
                    setShowTabTransaction(3);
                  }}
                >
                  Sukses
                </button>
                <button
                  className={
                    'text-gray-700 py-4 px-6 block hover:text-orange-500 border-b-2 focus:outline-none ' +
                    (showTabTransaction === 4
                      ? ' text-orange-500 border-orange-500 '
                      : ' hover:text-orange-500 border-transparent')
                  }
                  onClick={() => {
                    setShowTabTransaction(4);
                  }}
                >
                  Gagal
                </button>
              </div>
              <div className="py-4 bg-background-white">
                {/* Content */}
                {showTab}
              </div>

              {/* Pagination */}
              <div className="flex w-full bg-background-white mt-auto mb-12">
                <div className="flex ml-auto">
                  <button className="px-5 py-1 hover:bg-white hover:text-green-600  hover:border-green-600 border-transparent border mx-1 rounded">
                    Sebelum
                  </button>
                  <button className="px-3 py-1 bg-white text-green-600  border-green-600  border mx-1 rounded">
                    1
                  </button>
                  <button className="px-3 py-1 hover:bg-white hover:text-green-600  hover:border-green-600 border-transparent border mx-1 rounded">
                    2
                  </button>
                  <button className="px-3 py-1 hover:bg-white hover:text-green-600  hover:border-green-600 border-transparent border mx-1 rounded">
                    3
                  </button>
                  <button className="px-3 py-1 hover:bg-white hover:text-green-600  hover:border-green-600 border-transparent border mx-1 rounded">
                    4
                  </button>
                  <button className="px-3 py-1 hover:bg-white hover:text-green-600  hover:border-green-600 border-transparent border mx-1 rounded">
                    5
                  </button>
                  <button className="px-5 py-1 hover:bg-white hover:text-green-600  hover:border-green-600 border-transparent border mx-1 rounded">
                    Lanjut
                  </button>
                </div>
              </div>
              {/* Pagination End */}
            </div>
          </div>
        </section>
      </LayoutDashboard>
    </>
  );
};

export default Transaction;
